export default {"src":"/_next/static/media/Promoted.e7cc6655.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};